import React, { useContext } from 'react';
import Helmet from 'react-helmet';
import { isEqual } from 'lodash';
import {
  ELSNewRelicBrowserService,
  ELSCommonConfig
} from '@els/els-ui-common-react';
import {
  RecordObject
} from '../../models/common.models';
import { getBrandName } from '../../pages/ai-chat/ai-chat.utilities';
import { AppContext } from '../../components/app/AppProvider.component';

/**
 * This is a workaround while waiting the official release.
 * Helmet uses deep-equal and sometimes crashes on circular objects.
 * See: https://github.com/nfl/react-helmet/issues/373
 * The fix is in 6.x beta. Wait for official release
 */
Helmet.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps: RecordObject) {
  return !isEqual(this.props, nextProps);
};

export interface SEOData {
  title?: string;
}

const withHTMLHeadSEO = (data: SEOData = {}) => <P extends RecordObject>(BaseComponent?: React.ComponentType<P>): React.FC<P> => {
  const SEOComponent: React.FC<P> = (props: P) => {
    const { appState } = useContext(AppContext);

    const headScripts = [];
    try {
      // eslint-disable-next-line no-undef
      const { licenseKey, applicationID, accountID, trustKey, agentID } = JSON.parse(getNewRelicBrowserConfig());
      if (licenseKey && applicationID && accountID && trustKey && agentID) {
        headScripts.push({
          type: 'text/javascript',
          innerHTML: ELSNewRelicBrowserService.registerNewRelicBrowser({ licenseKey, applicationID, accountID, trustKey, agentID })
        });
      }
    } catch (e) {
      ELSCommonConfig.getLogger().debug('New Relic Browser is not enabled for the current environment');
    }

  const pageNamePrefix = getBrandName(appState) ? `${getBrandName(appState)} - ` : '';
  const title = data?.title ? `${pageNamePrefix}${data.title}` : pageNamePrefix;

    return (
      <>
        <Helmet title={title} script={headScripts}>
          <html lang="en" />
        </Helmet>
  {BaseComponent ? <BaseComponent {...(props as P)} /> : null}
      </>
    );
  };

  return SEOComponent;
};

export default withHTMLHeadSEO;
